var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},[_c('v-overlay',{attrs:{"opacity":0.6,"value":_vm.loading,"z-index":1000}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('processingRequest'))+" ")]),_c('v-progress-circular',{staticClass:"ml-4",attrs:{"indeterminate":"","color":"white","size":25}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }